import { Link } from "react-router-dom";
import { PUBLIC_ROUTES } from "../../routes";
import MarketingShell from "./MarketingShell";

const COMMITMENTS = [
  {
    title: "EU AI Act Article 12 &amp; 26(6)",
    body: "Every decision the robot acts on lands in the Intent Ledger with the record-keeping fields the Act expects — who decided, what it did, why, and where in the room it happened. Article 12 governs automatic logging; Article 26(6) governs how long a deployer must keep those logs.",
  },
  {
    title: "ISO 25785-1 alignment",
    body: "Actuators never lock rigid during a fault. The Edge Reflex enforces balance-operational behaviour, so the robot stays safe to be near even while it is failing.",
  },
  {
    title: "Auditor-ready exports",
    body: "Ledger entries are Ed25519-signed and chained. An auditor can verify any episode end-to-end without trusting our infrastructure — or us.",
  },
  {
    title: "Attestable data boundary",
    body: "Perception runs on the robot; raw video never leaves the site. The Egress Ledger itemises and signs every byte that does — so privacy is something a family, a DPO, or a regulator can verify, not just believe.",
  },
] as const;

export default function Compliance() {
  return (
    <MarketingShell>
      <section className="sg-hero">
        <div className="sg-hero-copy">
          <p className="sg-eyebrow">Compliance &amp; Safety</p>
          <h1>Designed for the operating posture regulators are converging on.</h1>
          <p className="sg-hero-text">
            Manifold Kinetics builds the evidence a regulator or an
            underwriter will ask for — the signed record, the
            deterministic reflex, the exportable safety case — as a
            first-class part of the system, not an afterthought.
          </p>
          <div className="sg-hero-actions">
            <Link to={PUBLIC_ROUTES.signup} className="sg-btn sg-btn-primary">
              Request a pilot
            </Link>
            <Link to={PUBLIC_ROUTES.productEdgeReflex} className="sg-btn sg-btn-secondary">
              See Edge Reflex
            </Link>
          </div>
        </div>
      </section>

      <section className="sg-pillars">
        <div className="sg-section-heading compact">
          <p className="sg-section-kicker">Commitments</p>
          <h2>What the platform takes off your plate.</h2>
        </div>
        <div className="sg-pillars-grid grid-2">
          {COMMITMENTS.map((item) => (
            <article className="sg-pillar" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="sg-final-cta">
        <p className="sg-section-kicker">Where we are honestly</p>
        <h2>Scaffolding, not certification — yet.</h2>
        <p>
          We build the evidence trail first and pursue formal
          conformity assessment with design partners, one deployment
          at a time. If your regulator or your underwriter has a
          specific ask, we want to hear it — that conversation is
          usually where a pilot starts.
        </p>
        <div className="sg-hero-actions center">
          <Link to={PUBLIC_ROUTES.signup} className="sg-btn sg-btn-primary">
            Request a pilot
          </Link>
          <Link to={PUBLIC_ROUTES.howItWorks} className="sg-btn sg-btn-secondary">
            How it works
          </Link>
        </div>
      </section>
    </MarketingShell>
  );
}
